import React, { useEffect, useState } from "react";
import { Col, Label, Row } from "reactstrap";
import axios from "axios";
import { routes } from "./General";
import AsyncSelect from "react-select/async";
import { BlkField } from "../coms/BlkField";
import { useDispatch, useSelector } from "react-redux";
import { do_login } from "../sec/actions";

export const ComboAsegurado = ({ setFieldValue, name, alert, values }) => {
    const [valor, setValor] = useState({});
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);

    useEffect(() => {
        if (!values) {
            setValor(null);
        }
    }, [values]);

    const getClientes = (value, callback) => {
        if (value.length > 0) {
            axios
                .get(routes.apiGen + "/aseguradosvam", { params: { cedula: value.toUpperCase() } })
                .then(resp => {
                    let data = resp.data;
                    data.forEach(p => {
                        p.label = p.cedula + " - " + p.nmCliente + " " + (p.apCliente ? p.apCliente : "");
                        p.value = p.cedula;
                    });
                    data.sort((p1, p2) => p1.cedula.localeCompare(p2.cedula));
                    callback(data);
                })
                .catch(error => {
                    alert.current.show_error("Error al consultar " + error);
                });
        } else {
            callback([]);
        }
    };

    const handleCedula = cedula => {
        const current = alert.current;
        if (cedula !== "") {
            let usuario = JSON.parse(JSON.stringify(user));
            usuario.cedula = cedula;
            dispatch(do_login({ ...usuario }));
        } else {
            current.show_error("Sin cédula");
        }
    };

    return (
        <Row>
            <Col>
                <div>
                    <Label>Titular: </Label>
                    <BlkField
                        name={name}
                        component={AsyncSelect}
                        loadOptions={getClientes}
                        value={valor}
                        placeholder="Cliente"
                        onChange={e => {
                            setFieldValue(name, e.value);
                            setValor(e);
                            handleCedula(e.value);
                        }}
                        classNamePrefix="react-select"
                        className="react-select"
                    ></BlkField>
                </div>
            </Col>
        </Row>
    );
};
